{
  "version": 1,
  "asset_id": "1d90941e-f750-49f3-963c-922d01d6d5b1",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/1d90941e-f750-49f3-963c-922d01d6d5b1/bjorn-aalbers.png",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/1d90941e-f750-49f3-963c-922d01d6d5b1/bjorn-aalbers.png",
  "original_filename": "bjorn-aalbers.png",
  "size": 383209,
  "content_type": "image/png",
  "created_at": "2026-06-30T10:13:22Z"
}
